function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M16 1.074c0-.195 0-.586-.189-.781a.892.892 0 00-1.322 0l-9.234 9.46-3.65-3.879a.892.892 0 00-1.322 0 .967.967 0 000 1.368l4.406 4.465c.377.39.944.39 1.322 0l9.8-10.047c.189 0 .189-.39.189-.586z",
  fill: "#4C4D4C",
  fillRule: "evenodd"
});

function SvgCheckmark(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 16 12"
  }, props), _ref);
}

export default __webpack_public_path__ + "assets/images/checkmark.d0a18372.svg";
export { SvgCheckmark as ReactComponent };